import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Spinner from "../../../components/Spinner";

import config from "config/common";
import lib from "lib/commons";

Modal.setAppElement("#root");

const ModalMission = ({
  modalStatus,
  closeModal,
  checkMatch,
  isCheckingMatch,
  playNormal
}) => {
  const afterOpenModal = () => {};

  const selfClose = (event) => {
    event.preventDefault();
    closeModal();
  };

  const handleCheckMatch = (e) => {
    e.preventDefault()

    if(isCheckingMatch) {
      return
    }

    checkMatch()
  }

  return (
      <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-mission"
    >
      <h2>
        <img src="/images/title-mission.png" alt="" className="title-modal"/>
      </h2>
      <div className="modal-description">
        <div className="mission">
          <div className="mission__content">
            <p>
              Thắng 1 trận bất kỳ <br/>
              <span>({playNormal > 0 ? 'Đã hoàn thành' : 'Chưa hoàn thành'})</span>
            </p>
          </div>
          {/* {playNormal < 1 && (
            <a href="#" className="mission__btn" onClick={e => handleCheckMatch(e)}>
              Cập nhật nhiệm vụ
            </a>
          )} */}
        </div>
      </div>
    </Modal>
  )
}

export default ModalMission